<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-menu"></i> 属性列表
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <!-- 统计卡片 -->
      <div class="stat-cards">
        <div class="stat-card">
          <div class="stat-icon total"><i class="el-icon-document"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ total }}</div>
            <div class="stat-label">总属性数</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon input-type"><i class="el-icon-edit"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ inputTypeCount }}</div>
            <div class="stat-label">输入类型</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon select-type"><i class="el-icon-select"></i></div>
          <div class="stat-info">
            <div class="stat-value">{{ selectTypeCount }}</div>
            <div class="stat-label">选择类型</div>
          </div>
        </div>
      </div>

      <!-- 搜索栏 -->
      <div class="search-bar">
        <el-form :inline="true" :model="searchForm" size="small" @submit.native.prevent>
          <el-form-item label="属性名称">
            <el-input
              v-model="searchForm.name"
              placeholder="请输入属性名称"
              prefix-icon="el-icon-search"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchSubmit" icon="el-icon-search">搜索</el-button>
            <el-button type="success" @click="addData" icon="el-icon-plus">新增属性</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 表格 -->
      <div class="table-wrapper">
        <el-table
          ref="multipleTable"
          :data="tableLoadData"
          stripe
          border
          size="medium"
          v-loading="loading"
          :header-cell-style="headerCellStyle"
          :row-style="rowStyle"
        >
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div class="expand-table">
                <el-table
                  :data="scope.row.val || []"
                  size="small"
                  :header-cell-style="headerCellStyle"
                >
                  <el-table-column label="规格名称" prop="name"></el-table-column>
                  <el-table-column label="操作" width="100">
                    <template slot-scope="props">
                      <el-button type="text" class="delete-btn" @click="delVal(props.row)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>

          <el-table-column :index="indexMethod" type="index" label="序号" width="60" align="center"></el-table-column>
          <el-table-column label="属性名称" prop="attr_name" min-width="120" show-overflow-tooltip></el-table-column>
          <el-table-column label="所属分类" width="140" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-tag size="small" effect="plain">{{ scope.row.type ? scope.row.type.cat_name : '-' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="输入类型" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.attr_input_type === 0 ? 'info' : 'primary'" effect="plain" size="small">
                {{ scope.row.attr_input_type === 0 ? '输入' : '选择' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="是否多选" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.attr_type === 0 ? 'info' : 'success'" effect="plain" size="small">
                {{ scope.row.attr_type === 0 ? '单选' : '多选' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="属性组" prop="attr_group" width="120" show-overflow-tooltip></el-table-column>
          <el-table-column label="排序" prop="sort_order" width="100" align="center"></el-table-column>
          <el-table-column label="操作" width="220" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" class="edit-btn" @click="goEdit(scope.row)">
                <i class="el-icon-edit"></i> 编辑
              </el-button>
              <el-button type="text" class="delete-btn" @click="del(scope.row)">
                <i class="el-icon-delete"></i> 删除
              </el-button>
              <el-button type="text" class="spec-btn" @click="addVal(scope.row)">
                <i class="el-icon-plus"></i> 规格
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 空状态 -->
      <div v-if="tableLoadData.length === 0 && !loading" class="empty-state">
        <i class="el-icon-menu"></i>
        <p>暂无属性数据</p>
        <el-button type="primary" size="small" @click="addData">立即添加</el-button>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper" v-if="total > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>

    <!-- 新增/编辑属性弹框 -->
    <eAttr
      :formData="formData"
      :visible.sync="visible"
      :title="title"
      :closeForm="closeForm"
    />

    <!-- 新增规格弹框 -->
    <eAttrVal
      :formData="formData1"
      :visible.sync="visible1"
      :title="title1"
      :closeForm="closeForm1"
    />
  </div>
</template>

<script>
import eAttr from "../common/eAttr.vue";
import eAttrVal from "../common/eAttrVal.vue";
export default {
  name: "attrList",
  components: { eAttr, eAttrVal },
  data() {
    return {
      loading: false,
      formData: {},
      title: '',
      visible: false,
      formData1: {},
      title1: '',
      visible1: false,
      searchForm: { name: "" },
      tableLoadData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      showType: '',
      roleList: [],
      rules: {
        name: [
          { required: true, message: '请输入名称', trigger: 'blur' },
          { min: 3, max: 15, message: "长度在 3 到 15 个字符", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    inputTypeCount() {
      return this.tableLoadData.filter(item => item.attr_input_type === 0).length;
    },
    selectTypeCount() {
      return this.tableLoadData.filter(item => item.attr_input_type === 1).length;
    }
  },
  created() {
    this.showType = this.$route.query.showType;
    this.DataList();
    this.departData();
  },
  methods: {
    headerCellStyle() {
      return { background: '#f5f7fa', color: '#1f2d3d', fontWeight: '500', fontSize: '14px', borderBottom: '1px solid #e4e7ed' };
    },
    rowStyle() {
      return { cursor: 'pointer' };
    },
    closeForm() {
      this.title = "";
      this.pageNum = 1;
      this.DataList();
      this.visible = false;
    },
    closeForm1() {
      this.title1 = "";
      this.pageNum = 1;
      this.DataList();
      this.visible1 = false;
    },
    addVal(row) {
      this.formData1 = {
        attr_id: row.attr_id,
        attr_name: row.attr_name,
        val: row.val || []
      };
      this.title1 = "新增产品规格";
      this.visible1 = true;
    },
    addData() {
      this.title = "新增产品属性";
      this.formData = {};
      this.visible = true;
    },
    goEdit(row) {
      this.title = "修改产品属性";
      this.formData = {
        attr_name: row.attr_name,
        attr_input_type: row.attr_input_type,
        cat_id: row.cat_id,
        attr_id: row.attr_id
      };
      this.visible = true;
    },
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    DataList() {
      this.loading = true;
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        shop_id: sessionStorage.getItem('shop_id')
      };
      if (this.searchForm.name) param.name = this.searchForm.name;
      this.$axios.goodsAttributesListP(param).then(res => {
        if (res.code == 200) {
          this.tableLoadData = res.data.data || [];
          this.total = res.data.total || 0;
        }
        this.loading = false;
      }).catch(error => {
        console.log(error);
        this.loading = false;
      });
    },
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.pageNum = 1;
      this.DataList();
    },
    handleCurrentChange(newPage) {
      this.pageNum = newPage;
      this.DataList();
    },
    departData() {
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
      };
      this.$axios.findTree(param).then(res => {
        if (res.code == 200) this.rightslist = res.data.data;
      }).catch(error => console.log(error));
    },
    searchSubmit() {
      this.pageNum = 1;
      this.DataList();
    },
    delVal(e) {
      this.$confirm('此操作将删除该规格, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const param = {
          operator_id: sessionStorage.getItem('user_id'),
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          id: e.id,
        };
        this.$axios.goodsAttributesValDel(param).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.pageNum = 1;
            this.DataList();
          } else {
            this.$message.error(res.msg);
          }
        }).catch(error => console.log(error));
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    del(e) {
      this.$confirm('此操作将删除该属性, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const param = {
          shop_id: sessionStorage.getItem('shop_id'),
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          attr_id: e.attr_id,
        };
        this.$axios.goodsAttributesDel(param).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg);
            this.DataList();
          } else {
            this.$message.error(res.msg);
          }
        }).catch(error => console.log(error));
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    }
  }
};
</script>

<style lang="scss" scoped>
/* 支付宝风格容器 */
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

/* 面包屑 */
.breadcrumb-wrapper {
  margin-bottom: 16px;
  .el-breadcrumb {
    font-size: 14px;
    i {
      margin-right: 4px;
    }
  }
}

/* 卡片样式 */
.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  &:hover {
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08);
  }
  ::v-deep .el-card__body {
    padding: 20px 24px;
  }
}

/* 统计卡片 */
.stat-cards {
  display: flex;
  gap: 20px;
  margin-bottom: 24px;
  flex-wrap: wrap;
  .stat-card {
    flex: 1;
    min-width: 160px;
    background: linear-gradient(135deg, #fff 0%, #f8f9fc 100%);
    border-radius: 16px;
    padding: 20px;
    display: flex;
    align-items: center;
    gap: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
    .stat-icon {
      width: 48px;
      height: 48px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      color: #fff;
      &.total {
        background: linear-gradient(135deg, #1677ff, #4096ff);
      }
      &.input-type {
        background: linear-gradient(135deg, #00b578, #1acd8c);
      }
      &.select-type {
        background: linear-gradient(135deg, #e6a23c, #ebb563);
      }
    }
    .stat-info {
      .stat-value {
        font-size: 28px;
        font-weight: 700;
        color: #1f2d3d;
        line-height: 1.2;
      }
      .stat-label {
        font-size: 13px;
        color: #8c8f98;
        margin-top: 4px;
      }
    }
  }
}

/* 搜索栏 */
.search-bar {
  background: #f8f9fc;
  padding: 16px 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  .el-form-item {
    margin-bottom: 0;
  }
  .el-input ::v-deep .el-input__inner {
    border-radius: 20px;
  }
  .el-button {
    border-radius: 20px;
    padding: 8px 18px;
  }
  .el-button--primary {
    background: #1677ff;
    border-color: #1677ff;
    &:hover {
      background: #4096ff;
      border-color: #4096ff;
    }
  }
  .el-button--success {
    background: #00b578;
    border-color: #00b578;
    &:hover {
      background: #1acd8c;
      border-color: #1acd8c;
    }
  }
}

/* 表格样式 */
.table-wrapper {
  margin-bottom: 20px;
  min-height: 350px;
}
.el-table {
  border-radius: 12px;
  overflow: hidden;
  &::before {
    display: none;
  }
  th {
    background: #fafbfc !important;
    font-weight: 500;
  }
  td {
    border-bottom: 1px solid #f0f0f0;
  }
  .el-table__row {
    transition: background 0.2s;
    &:hover {
      background: #f8f9fc;
    }
  }
}
.expand-table {
  padding: 12px 20px;
  background: #fafbfc;
  border-radius: 8px;
}
.edit-btn {
  color: #1677ff;
  &:hover {
    color: #4096ff;
  }
}
.delete-btn {
  color: #fa6b6b;
  &:hover {
    color: #ff4d4f;
  }
}
.spec-btn {
  color: #00b578;
  &:hover {
    color: #1acd8c;
  }
}

/* 空状态 */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #c0c4cc;
  i {
    font-size: 64px;
  }
  p {
    margin-top: 16px;
    font-size: 14px;
  }
  .el-button {
    margin-top: 20px;
    border-radius: 20px;
  }
}

/* 分页 */
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
  ::v-deep .el-pagination .el-pager li.active {
    background: #1677ff;
    color: #fff;
  }
}

/* 弹框样式（确保子组件也适用） */
::v-deep .el-dialog {
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
  .el-dialog__header {
    background: linear-gradient(135deg, #1677ff 0%, #4096ff 100%);
    padding: 16px 24px;
    .el-dialog__title {
      color: #fff;
      font-size: 18px;
      font-weight: 500;
    }
  }
  .el-dialog__body {
    padding: 24px;
  }
  .el-dialog__footer {
    padding: 16px 24px 24px;
    border-top: 1px solid #f0f0f0;
  }
  .el-button {
    border-radius: 24px;
    padding: 8px 20px;
  }
  .el-button--primary {
    background: #1677ff;
    border-color: #1677ff;
    &:hover {
      background: #4096ff;
      border-color: #4096ff;
    }
  }
}
</style>